import React from 'react'
import Navbar from '../Components/Navbar';
import UXcasestudies from '../Components/UXcasestudies';
import Footer from '../Components/Footer';
// import { Link } from 'react-router-dom';
// import { BrowserRouter } from "react-router-dom"

const Casestudies = () => {
  return (
    <div>
        <Navbar />

        <UXcasestudies />
  
        <Footer />
    </div>
  )
}

export default Casestudies